import { ReactNode } from 'react';

export enum SIDEBAR_ITEM_TYPES {
  TEXT = 'text',
  TEMPLATES = 'templates',
  WIDGETS = 'widgets',
  BUILDER = 'builder',
  IMAGES = 'images',
  SCHEDULE = 'schedule',
  TAGS = 'tags'
  // OTHER = 'other'
}

export interface SidebarItemData {
  type: SIDEBAR_ITEM_TYPES;
  name: string;
  icon: ReactNode;
}
